<template>
    <div  class="m-updown">
        <div class="updown-tip-title ta-center" id="js-updown-title">
            <span class="line-a"></span>&nbsp;<data-text></data-text>&nbsp;<span class="line-b"></span>
        </div>
        <div class="box-card">
            <div class="sse-wrap" v-if="todayIsTransdate">
                <template v-if="todayIsTransdate">
                    <div class="sseTimeCon ta-center" v-if="nowTimeSection===0">
                        距{{nowTime.months}}月{{nowTime.days}}号预测结束剩
                        {{leftSeconds}}
                    </div>
                    <div v-else-if="nowTimeSection===2" class="sseTimeCon ta-center">
                        距{{tomorrow.months}}月{{tomorrow.days}}号预测结束剩
                        {{leftSeconds}}
                    </div>
                    <div v-else  class="sseTimeCon ta-center">
                        {{nowTime.months}}月{{nowTime.days}}号预测已结束
                    </div>
                </template>
                <template v-else>
                    <div class="sseTimeCon ta-center">
                        距{{tomorrow.months}}月{{tomorrow.days}}号预测结束剩
                        <!-- <k-left-time :value="leftSeconds * 1000"/> -->
                        {{leftSeconds}}
                    </div>
                </template>                               
            </div>
            <shangzheng :data="shangzheng"></shangzheng>
            <div class="gamTitle"></div>
            <template v-if="summary">                
                <k-progress :total="summary.coinTotal" :left="summary.coinUp" />
            </template>

            <div class="gamProGold">
                <van-row type="flex" gutter="20" v-if="summary">
                    <van-col span="12">
                        <span class="up-text"></span> {{summary.coinUp || 0}}金币
                    </van-col>
                    <van-col span="12" class="ta-right">
                        <span class="down-text"></span> {{summary.coinDown || 0}}金币
                    </van-col>
                </van-row>
            </div>

            <div class="gamBtnPart">
                <van-row class="gamPicArea"  v-if="summary">
                    <van-col span="12" class="ta-center">
                        <button class="gamBtnUpDownLeft" :class="isDisabled" href="javascript:;" @click="game(1)" data-updown-status="1">
                            <div class="big-text">押涨</div>
                            <span class="gamPersonUp" id="gamUpAllPer">{{summary.userUp || 0}}</span><span class="gamPersonUp">人</span>
                        </button>
                    </van-col>
                    <van-col span="12" class="ta-center">
                        <button class="gamBtnUpDownRight" :class="isDisabled" href="javascript:;" @click="game(2)" data-updown-status="2">
                            <div class="big-text">押跌</div>
                            <span class="gamPersonDown" id="gamDownAllPer">{{summary.userDown || 0}}</span><span class="gamPersonDown">人</span>
                        </button>
                    </van-col>
                </van-row>
            </div>
            <!--<div class="pd-v-sm" v-else>
                <van-button type="danger" block x-click="go.login">登录后才能押涨跌</van-button>
            </div>-->

            <div class="gamFinalResultTipCon">
                 <data-result></data-result>
            </div>

        </div>
        <combat-popup ref="combatPopup"></combat-popup>
        <van-dialog
            v-model = "showBetInfo"
            title = "下注成功"
            :overlay="true"
        >
            <div class="pd-sm" style="border-bottom:1px solid #eee;">
                <dl class="m-dl--box fts-24" v-if="betInfo">
                    <dd class="fts-32">
                        <strong class="upColor" v-if="betInfo.betType===1">押涨↑</strong>
                        <strong class="downColor" v-else-if="betInfo.betType===2">押跌↓</strong>&nbsp;
                        <strong :class="betInfo.betType===1?'upColor':'downColor'">{{betInfo.betNum}}注 = <k-num :value="betInfo.betNum*100"></k-num><i class="icon-gold"></i></strong>
                    </dd>
                    <dd><span>上证综指：</span>&nbsp;<span>{{betInfo.transDate.slice(0,10)}}</span></dd>
                    <dt>投注时间： <span>{{betInfo.ctime}}</span></dt>
                    <dd style="width:100%;">开奖时间：<span>{{betInfo.rewardTime}} 15:00后</span></dd>
                </dl>
            </div>            
        </van-dialog>
    </div>
</template>

<script>
    import { WZ } from '../../../common/globals'
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
    import UpdownDateText from '../../components/updown-date-text'
    import DateResul from '../../components/updown-result-date'
    import Shangzheng from './shangzheng'
    import Progress from '../../components/k-progress'
    import BetPopup from '../combat/combat-popup'
    import {
        commentPost
    } from '../../../api/g/comment'
    export default {
        data() {
            return {
                showBetInfo : false,
                betInfo : null,
                showTimer : false,
                objType: 10,
                objId: 1
            }
        },
        components :{
            'data-text' : UpdownDateText,
            'data-result' : DateResul,
            'shangzheng' : Shangzheng,
            'k-progress' : Progress,
            'combat-popup' : BetPopup,
        },
        computed: {
            ...mapState('config', ['baseConf']),
            ...mapGetters(['myUid','myGold']),
            ...mapGetters('timer', ['isBefore', 'isAfter', 'now', 'leftSecs','leftFor','isBetween']),
            ...mapGetters('home', ['tomorrow','nowTime','endTime', 'hasPut', 'transDate','todayIsTransdate', 'nowTimeSection', 'shangzheng', 'summary']),
            isDisabled(){
                if (this.hasPut) {
                    return 'disabled'
                } else  if(this.nowTimeSection===1 && this.todayIsTransdate){
                    return 'disabled'
                } else {
                    return ''
                }
            },
            pid(){
                return this.transDate.replace(/-/g,'') || ''
            },
            leftSeconds(){
                /* let endTime = this.baseConf.endTime
                if(this.todayIsTransdate){
                    if (this.nowTimeSection === 2){
                        let date = new Date(this.tomorrow['years'], +this.tomorrow['months']-1, this.tomorrow['days'], endTime['hours'], endTime['minutes'], endTime['seconds'])
                        return this.leftSecs(date.getTime())
                    } else {
                        let date = new Date(this.nowTime['years'], +this.nowTime['months']-1, this.nowTime['days'], endTime['hours'], endTime['minutes'], endTime['seconds'])
                        return this.leftSecs(date.getTime())
                    }
                } else {
                    let date = new Date(this.tomorrow['years'], +this.tomorrow['months']-1, this.tomorrow['days'], endTime['hours'], endTime['minutes'], endTime['seconds'])
                    return this.leftSecs(date.getTime())
                }*/ 
                
                return this.leftFor(this.endTime.times)
            },
            beginStart(){
                let todayBegin = this.baseConf.todayBegin || {};
                let nowDate = new Date(this.now)
                let date = new Date(+nowDate.getFullYear(), +nowDate.getMonth(), +nowDate.getDate(), todayBegin['hours'], todayBegin['minutes'], todayBegin['seconds']);
                
                return this.leftSecs(date.getTime());
                
            }
        },
        methods: {
            ...mapActions('home', ['gameStart','loadDaysumary','loadBetinfo']),
            ...mapActions('comment', ['getCommentList']),
            ...mapMutations('home', ['update']),
            async postComment(content) {
                const {objType, objId} = this
                const query = {
                    content, objType, objId
                }				
                try {                    
                    const R = await commentPost(query)
                    this.content = ''
                    this.getCommentList({
                        objType, 
                        objId,
                        pageNum: 4
                    })
                } catch (error) {
                    console.log(error)
                }
				
            },
            async game(type) {//type 1是涨 2是跌
                if(!type){
                    this.$toast('下注类型错误');
                }
                if(!this.check()) return
                await this.$refs.combatPopup.show(type).then(value => {
                    //console.log('弹层返回值：', value)
                    let {betNum, betType, pid, content} = value
                    this.gameStart({
                            betNum,  //int	押了多少注(1注100金币)
                            betType,  //int	押注类型(1表示压涨2表示压跌0表示全部)
                            pid : 1,  //int	第几期(暂时默认为1)
                            transDate   : this.transDate
                    }).then(R => {
                        //location.reload()                        
                        this.betInfo = R.betInfo
                        this.showBetInfo = true

                        //评论
                        if(content){
                            this.postComment(content)
                        }
                        this.loadBetinfo()
                        this.loadDaysumary()
                        //更新下注状态
                        this.update({
                            hasPut : 1
                        })
                    }).catch(({Body}) =>{
                        this.$toast(Body.message || Body.error_code)
                    })
                }).catch(() => {
                    console.log('弹层关闭，不需要任何处理')
                })
                
            },
            check(){
                if(!this.myUid) {
                    this.$dialog.confirm({
                        message: '请您先登录才能下注'
                    }).then(() => {
                        // on close
                        WZ.go('login')                    
                    })
                    return false
                }
                if(this.hasPut){
                    this.$toast('不要太贪心哦，您已经下注过了！');
                    return false
                }
                if(this.myGold < 100) {
                    this.$toast('金币不足先去赚点金币吧！');
                    return false
                }
                if(this.nowTimeSection === 1 && this.todayIsTransdate){
                    this.$toast('不在下注时间段！');
                    return false
                }
                return true
            }
        },
        watch: {
            beginStart(n){
                //console.log(n)
                if(n <= 0){
                    location.reload()
                }
            }
        },
    }
</script>